import moment from 'moment'

export const formatAvailabilityId = (availabilityId: string, format = 'HH:mm') => {
  return moment(availabilityId.slice(0, 19)).format(format)
}
